export const getDateFromString = (dateString) => {
  const dateSplit = dateString.split('/')
  return new Date(dateSplit[2], parseInt(dateSplit[1]) - 1, dateSplit[0])
}



// WEBPACK FOOTER //
// ./src/utils/date.js